module.exports = __webpack_public_path__ + "img/bank-submit.27ada259.png";